import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ベトナムへのゲートウェイ from "./sections/ベトナムへのゲートウェイ";
import 会社概要 from "./sections/会社概要";
import 当社の専門知識 from "./sections/当社の専門知識";
import SeikoJirei from "./sections/SeikoJirei";
import NazeBetonamuNanoka from "./sections/NazeBetonamuNanoka";
import FreeConsultation from "./sections/FreeConsultation";
import CustomerVoices from "./sections/CustomerVoices";
import Footer from "@/reusable_sections/Footer";
import PostSection from "./sections/PostSection";
export default function HomePage() {
  return <div>
      <Header />
      <ベトナムへのゲートウェイ />
      <会社概要 />
      <当社の専門知識 />
      <SeikoJirei />
      <PostSection />
      <NazeBetonamuNanoka />
      <FreeConsultation />
      <CustomerVoices />
      <Footer />
    </div>;
}